import { useI18n } from "../lib/i18n";
import { useCMS, useCText } from "../lib/cms";

function resolveImage(url, fallback) {
  if (!url) return fallback;
  if (url.startsWith("http")) return url;
  return `${process.env.REACT_APP_BACKEND_URL || ""}${url}`;
}

export default function About() {
  const { t } = useI18n();
  const title = useCText("about.title", "about.title");
  const body = useCText("about.body", "about.body.default");
  // Read the CMS value directly: useCText falls back to the key name ("image.about.url")
  // when the field is empty, which rendered a broken image.
  const { blocks } = useCMS();
  const aboutImage = blocks?.["image.about.url"]?.es || "";
  const gallery = (blocks?.["gallery.about"]?.es || "").split("\n").map((u) => u.trim()).filter(Boolean);
  const imageSrc = resolveImage(aboutImage, null);

  return (
    <div className="max-w-[1600px] mx-auto px-5 md:px-10 pt-10 md:pt-14" data-testid="about-page">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-7">
          <h1 className="text-2xl md:text-4xl font-medium leading-tight mb-8" data-testid="about-title">
            {title}
          </h1>
          <div className="text-sm md:text-base leading-relaxed text-foreground/90 space-y-5 whitespace-pre-line">
            {body.split("\n\n").map((paragraph, i) => (
              <p key={i}>{paragraph}</p>
            ))}
          </div>
        </div>
        {imageSrc && (
          <div className="md:col-span-5">
            <div className="aspect-[3/4] bg-[hsl(var(--muted))] overflow-hidden">
              <img src={imageSrc} alt="" className="w-full h-full object-cover" />
            </div>
          </div>
        )}
      </div>
      {gallery.length > 0 && (
        <div className="mt-14 md:mt-20 grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4" data-testid="about-gallery">
          {gallery.map((src, i) => (
            <div key={src + i} className="aspect-square bg-[hsl(var(--muted))] overflow-hidden">
              <img src={resolveImage(src, null)} alt="" loading="lazy" className="w-full h-full object-cover" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
